<script setup>
import { ref, computed, watch, onBeforeMount, nextTick } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useCampaignsStore } from "@/stores/campaigns";
import { useMediaStore } from "@/stores/media";
import { useSitesStore } from "@/stores/sites";
import { useAreasStore } from "@/stores/areas";
import { useDevicesStore } from "@/stores/devices";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();
const uiStore = useUiStore();
const campaignsStore = useCampaignsStore();
const mediaStore = useMediaStore();
const sitesStore = useSitesStore();
const areasStore = useAreasStore();
const devicesStore = useDevicesStore();
import AgentLayout from "@/views/layouts/AgentLayout.vue";
import PageHeader from "@/components/shared/PageHeader.vue";
import DBreadcrumb from "@/components/shared/DBreadcrumb.vue";
const companyId = useCompanyStore().companyId;

const currentStep = ref(1);
const adFormat = ref("screensaver"); // 'screensaver' | 'topbar' | 'slider_basic'
const id = ref(null);
const adName = ref("");
const storesOptions = ref([]);
const isStoresLoading = ref(false);
const areasOptions = ref([]);
const isAreasLoading = ref(false);
const devicesOptions = ref([]);
const isDevicesLoading = ref(false);
const update = ref(false);
const breadcrumbItems = ref([]);
const errors = ref({});
// Campaign / Playlist State
const campaignItems = ref([]);
const showMediaModal = ref(false);
const mediaSearchQuery = ref("");
const isSearching = ref(false);
let searchTimeout = null;

const selectAllStores = ref(false);
const selectedStores = ref([]);

const selectAllAreas = ref(false);
const selectedAreas = ref([]);

const selectAllDevices = ref(false);
const selectedDevices = ref([]);

watch(mediaSearchQuery, () => {
  isSearching.value = true;
  if (searchTimeout) clearTimeout(searchTimeout);
  searchTimeout = setTimeout(() => {
    isSearching.value = false;
  }, 500);
});

const settings = ref({
  screensaver: {
    showTouchToStart: true,
    touchToStartX: 50,
    touchToStartY: 70,
    touchToStartColor: "#91AA9F",
  },
});
const isSubmitted = ref(false);

const schedules = ref([
  {
    id: Date.now(),
    scheduleFrom: null,
    scheduleTo: null,
    startTime: null,
    endTime: null,
    scheduleType: { name: "always", description: "Always" },
    daysOfWeek: [],
    daysOfMonth: [],
    monthsOfYear: [],
  },
]);

const scheduleTypeOptions = ref([
  { name: "always", description: "Always" },
  { name: "weekly", description: "Weekly" },
  { name: "monthly", description: "Monthly" },
  { name: "yearly", description: "Yearly" },
]);

const daysOfWeekOptions = ref([
  { id: 1, name: "Monday" },
  { id: 2, name: "Tuesday" },
  { id: 3, name: "Wednesday" },
  { id: 4, name: "Thursday" },
  { id: 5, name: "Friday" },
  { id: 6, name: "Saturday" },
  { id: 7, name: "Sunday" },
]);
const daysOfMonthOptions = ref([
  { id: 1, name: "1" },
  { id: 2, name: "2" },
  { id: 3, name: "3" },
  { id: 4, name: "4" },
  { id: 5, name: "5" },
  { id: 6, name: "6" },
  { id: 7, name: "7" },
  { id: 8, name: "8" },
  { id: 9, name: "9" },
  { id: 10, name: "10" },
  { id: 11, name: "11" },
  { id: 12, name: "12" },
  { id: 13, name: "13" },
  { id: 14, name: "14" },
  { id: 15, name: "15" },
  { id: 16, name: "16" },
  { id: 17, name: "17" },
  { id: 18, name: "18" },
  { id: 19, name: "19" },
  { id: 20, name: "20" },
  { id: 21, name: "21" },
  { id: 22, name: "22" },
  { id: 23, name: "23" },
  { id: 24, name: "24" },
  { id: 25, name: "25" },
  { id: 26, name: "26" },
  { id: 27, name: "27" },
  { id: 28, name: "28" },
  { id: 29, name: "29" },
  { id: 30, name: "30" },
  { id: 31, name: "31" },
]);
const monthsOfYearOptions = ref([
  { id: 1, name: "January" },
  { id: 2, name: "February" },
  { id: 3, name: "March" },
  { id: 4, name: "April" },
  { id: 5, name: "May" },
  { id: 6, name: "June" },
  { id: 7, name: "July" },
  { id: 8, name: "August" },
  { id: 9, name: "September" },
  { id: 10, name: "October" },
  { id: 11, name: "November" },
  { id: 12, name: "December" },
]);

// Mock Media Data
const availableMedia = ref([
  // {
  //   id: 1,
  //   name: "hero_banner_main.jpg",
  //   type: "image",
  //   url: "https://placehold.co/1920x1080/e2e8f0/1e293b?text=Hero+Banner",
  //   selected: false,
  // },
  // {
  //   id: 2,
  //   name: "social_post_design.png",
  //   type: "image",
  //   url: "https://placehold.co/1080x1080/f1f5f9/475569?text=Social+Post",
  //   selected: false,
  // },
  // {
  //   id: 3,
  //   name: "promo_video_q4.mp4",
  //   type: "video",
  //   url: "https://placehold.co/1920x1080/334155/ffffff?text=Promo+Video",
  //   selected: false,
  // },
  // {
  //   id: 4,
  //   name: "meeting_notes_sketch.jpg",
  //   type: "image",
  //   url: "https://placehold.co/1920x1080/e2e8f0/1e293b?text=Meeting+Notes",
  //   selected: false,
  // },
  // {
  //   id: 6,
  //   name: "analytics_overview.png",
  //   type: "image",
  //   url: "https://placehold.co/800x600/f0fdf4/166534?text=Analytics",
  //   selected: false,
  // },
]);

const validate = () => {
  errors.value = {};
  let isValid = true;

  if (!adName.value.trim()) {
    errors.value.adName = "Campaign name is required";
    isValid = false;
  }

  if (campaignItems.value.length === 0) {
    errors.value.items = "At least one media item is required";
    isValid = false;
  }

  if (
    selectedStores.value.length === 0 &&
    selectedAreas.value.length === 0 &&
    selectedDevices.value.length === 0
  ) {
    errors.value.targeting = "Select at least one store, area, or device";
    isValid = false;
  }

  const hasValidSchedule = schedules.value.some((s) => s.scheduleFrom);
  if (!hasValidSchedule) {
    errors.value.schedules =
      "At least one schedule with a start date is required";
    isValid = false;
  }

  if (
    adFormat.value === "screensaver" &&
    settings.value.screensaver.showTouchToStart
  ) {
    const { touchToStartX, touchToStartY } = settings.value.screensaver;

    if (
      touchToStartX === "" ||
      touchToStartX === null ||
      touchToStartX < 0 ||
      touchToStartX > 100
    ) {
      errors.value.touchToStartX = "Pos X must be between 0 and 100";
      isValid = false;
    }

    if (
      touchToStartY === "" ||
      touchToStartY === null ||
      touchToStartY < 0 ||
      touchToStartY > 100
    ) {
      errors.value.touchToStartY = "Pos Y must be between 0 and 100";
      isValid = false;
    }
  }

  return isValid;
};

// Clear errors on input
watch(adName, (val) => {
  if (val.trim()) {
    delete errors.value.adName;
  }
});

watch(
  () => campaignItems.value.length,
  (len) => {
    if (len > 0) delete errors.value.items;
  },
);

watch(
  () => [selectedStores.value.length, selectedAreas.value.length, selectedDevices.value.length],
  ([stores, areas, devices]) => {
    if (stores > 0 || areas > 0 || devices > 0) delete errors.value.targeting;
  },
);

watch(
  () => schedules.value.some((s) => s.scheduleFrom),
  (hasValidSchedule) => {
    if (hasValidSchedule) delete errors.value.schedules;
  },
);

const selectFormat = (format) => {
  adFormat.value = format;

  settings.value = {
    screensaver: {
      showTouchToStart: true,
      touchToStartX: 50,
      touchToStartY: 70,
      touchToStartColor: "#91AA9F",
    },
  };
};

const updateTouchToStart = () => {
  delete errors.value.touchToStartX;
  delete errors.value.touchToStartY;
  if (!settings.value.screensaver.showTouchToStart) {
    settings.value.screensaver.touchToStartX = 50;
    settings.value.screensaver.touchToStartY = 70;
    settings.value.screensaver.touchToStartColor = "#91AA9F";
  }
};

const selectableMedia = computed(() => {
  const addedIds = campaignItems.value.map((i) => i.id);
  let filtered = availableMedia.value.filter((m) => !addedIds.includes(m.id));

  if (mediaSearchQuery.value) {
    const query = mediaSearchQuery.value.toLowerCase();
    filtered = filtered.filter((m) => m.name.toLowerCase().includes(query));
  }

  return filtered;
});

const fetchAllMedia = async () => {
  await mediaStore
    .fetchAllMedia(companyId)
    .then((res) => {
      availableMedia.value = res.data;
    })
    .catch(() => {
    });
};

// Step Navigation
const nextStep = () => {
  if (currentStep.value < 2) currentStep.value++;
};
const prevStep = () => {
  if (currentStep.value > 1) currentStep.value--;
};

const addSchedule = () => {
  schedules.value.push({
    id: Date.now() + Math.random(),
    scheduleFrom: null,
    scheduleTo: null,
    startTime: null,
    endTime: null,
    scheduleType: { name: "always", description: "Always" },
    daysOfWeek: [],
    daysOfMonth: [],
    monthsOfYear: [],
  });
};

const removeSchedule = (index) => {
  if (schedules.value.length > 1) {
    schedules.value.splice(index, 1);
  }
};

const onScheduleTypeChange = (schedule) => {
  schedule.daysOfWeek = [];
  schedule.daysOfMonth = [];
  schedule.monthsOfYear = [];
};

// Modal Functions
const openMediaModal = () => {
  availableMedia.value.forEach((m) => (m.selected = false));
  showMediaModal.value = true;
};

const toggleMediaSelection = (media) => {
  media.selected = !media.selected;
};

const changeScheduleFromDates = (schedule) => {
  schedule.scheduleTo = null;
};

const disabledDates = computed(() => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to start of day
  return (date) => {
    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0); // Reset time to start of day
    return compareDate < today;
  };
});

const getDisabledScheduleToDates = (schedule) => {
  if (!schedule.scheduleFrom) return () => false;
  const today = new Date(schedule.scheduleFrom);
  return (date) => {
    const compareDate = new Date(date);
    return compareDate <= today;
  };
};

// const searchByName = (val, type) => {
//   if (val && val.length >= 3) {
//     if (type === "store") {
//       fetchStoresByName(val);
//     } else if (type === "area") {
//       fetchAreasByName(val);
//     } else if (type === "device") {
//       fetchDevicesByName(val);
//     }
//   }
// };

const fetchStoresByName = async () => {
  isStoresLoading.value = true;
  storesOptions.value = [];
  await sitesStore
    .fetchSitesBySearch({ companyId, params: { search: "" } })
    .then((res) => {
      isStoresLoading.value = false;
      storesOptions.value = res.data;
    })
    .catch(() => { isStoresLoading.value = false; });
};

const fetchAreasByName = async () => {
  isAreasLoading.value = true;
  areasOptions.value = [];
  await areasStore
    .fetchAreasBySearch({ companyId, params: { search: "" } })
    .then((res) => {
      isAreasLoading.value = false;
      areasOptions.value = res.data;
    })
    .catch(() => { isAreasLoading.value = false; });
};

const fetchDevicesByName = async () => {
  isDevicesLoading.value = true;
  devicesOptions.value = [];
  await devicesStore
    .fetchDevicesBySearch({ companyId, params: { search: "" } })
    .then((res) => {
      isDevicesLoading.value = false;
      devicesOptions.value = res.data;
    })
    .catch(() => { isDevicesLoading.value = false; });
};

const addSelectedMedia = () => {
  const selected = availableMedia.value.filter((m) => m.selected);
  selected.forEach((media) => {
    campaignItems.value.push({
      id: media.id,
      name: media.name,
      type: media.type,
      url: media.url,
      duration: 10,
      playUntilEnd: false,
    });
  });
  showMediaModal.value = false;
};

const removeCampaignItem = (index) => {
  campaignItems.value.splice(index, 1);
};

// Drag and Drop Logic
const draggedItemIndex = ref(null);

const onDragStart = (index, event) => {
  draggedItemIndex.value = index;
  event.dataTransfer.effectAllowed = "move";
  // specific opacity for better visual feedback usually handled by browser,
  // but we can add classes if we want
};

const onDragOver = (event) => {
  event.preventDefault(); // Necessary to allow dropping
  event.dataTransfer.dropEffect = "move";
};

const onDrop = (dropIndex) => {
  const draggedIndex = draggedItemIndex.value;
  if (draggedIndex === null || draggedIndex === dropIndex) return;

  const itemToMove = campaignItems.value[draggedIndex];
  campaignItems.value.splice(draggedIndex, 1);
  campaignItems.value.splice(dropIndex, 0, itemToMove);

  draggedItemIndex.value = null;
};

// const toggleLocation = (id) => {
//   const loc = availableLocations.value.find((l) => l.id === id);
//   if (loc) loc.selected = !loc.selected;
// };\

const formatTime = (time) => {
  if (!time) return null;
  if (typeof time === "string") return time;
  if (time.hours !== undefined) {
    const hours = String(time.hours).padStart(2, "0");
    const minutes = String(time.minutes).padStart(2, "0");
    const seconds = String(time.seconds || 0).padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  }
  return null;
};

const onSelectAllStoresChange = (event) => {
  selectedStores.value = event.checked
    ? storesOptions.value.map((item) => item.id)
    : [];

  selectAllStores.value = event.checked;
};

const onChangeStoresVal = (event) => {
  selectedStores.value = event.value;
  if (selectedStores.value.length === storesOptions.value.length) {
    selectAllStores.value = true;
  } else if (selectedStores.value.length < storesOptions.value.length) {
    selectAllStores.value = false;
  }
};

const getStoreName = (id) => {
  const found = storesOptions.value.find((s) => s.id === id);
  return found ? found.name : id;
};

const removeStore = (id) => {
  selectedStores.value = selectedStores.value.filter((uuid) => uuid !== id);
};

const onSelectAllAreasChange = (event) => {
  selectedAreas.value = event.checked
    ? areasOptions.value.map((item) => item.id)
    : [];

  selectAllAreas.value = event.checked;
};

const onChangeAreasVal = (event) => {
  selectedAreas.value = event.value;
  if (selectedAreas.value.length === areasOptions.value.length) {
    selectAllStores.value = true;
  } else if (selectedStores.value.length < storesOptions.value.length) {
    selectAllStores.value = false;
  }
};

const getAreaName = (id) => {
  const found = areasOptions.value.find((s) => s.id === id);
  return found ? found.name : id;
};

const removeArea = (id) => {
  selectedAreas.value = selectedAreas.value.filter((uuid) => uuid !== id);
};

const onSelectAllDevicesChange = (event) => {
  selectedDevices.value = event.checked
    ? devicesOptions.value.map((item) => item.id)
    : [];

  selectAllDevices.value = event.checked;
};

const onChangeDevicesVal = (event) => {
  selectedDevices.value = event.value;
  if (selectedDevices.value.length === devicesOptions.value.length) {
    selectAllDevices.value = true;
  } else if (selectedDevices.value.length < devicesOptions.value.length) {
    selectAllDevices.value = false;
  }
};

const getDeviceName = (id) => {
  const found = devicesOptions.value.find((s) => s.id === id);
  return found ? found.name : id;
};

const removeDevice = (id) => {
  selectedDevices.value = selectedDevices.value.filter((uuid) => uuid !== id);
};

const createPayload = (status) => {
  const payload = {
    name: adName.value,
    status: status, // 'draft' or 'published'
    format: adFormat.value,
    setting: settings.value,
    items: campaignItems.value.map((item) => ({
      id: item.id,
      name: item.name,
      duration: item.duration,
      playUntilEnd: item.playUntilEnd,
    })),
    targeting: {
      stores: selectedStores.value,
      areas: selectedAreas.value,
      devices: selectedDevices.value,
    },
    schedules: schedules.value.map((s) => ({
      startDate: s.scheduleFrom,
      endDate: s.scheduleTo,
      startTime: formatTime(s.startTime),
      endTime: formatTime(s.endTime),
      type: s.scheduleType ? s.scheduleType.name : "always",
      recurrence: {
        daysOfWeek: s.daysOfWeek.map((d) => d.id),
        daysOfMonth: s.daysOfMonth.map((d) => d.id),
        monthsOfYear: s.monthsOfYear.map((m) => m.id),
      },
    })),
  };
  return payload;
};

const saveDraft = () => {
  errors.value = {};
  if (!adName.value.trim()) {
    errors.value.adName = "Campaign name is required";
    currentStep.value = 1;
    nextTick(() => {
      const el = document.getElementById("campaign-name");
      if (el) el.focus();
    });
    return;
  }
  isSubmitted.value = true;
  const payload = createPayload("draft");
  if (!update.value) createCampaign(payload);
  else editCampaign(payload);
};

const saveAndPublish = () => {
  if (!validate()) {
    if (errors.value.adName) {
      currentStep.value = 1;
      nextTick(() => {
        const el = document.getElementById("campaign-name");
        if (el) el.focus();
      });
    } else if (errors.value.items) {
      currentStep.value = 1;
      nextTick(() => {
        const el = document.getElementById("campaign-items");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      });
    } else if (errors.value.touchToStartX || errors.value.touchToStartY) {
      currentStep.value = 1;
      nextTick(() => {
        const elId = errors.value.touchToStartX ? "touch-pos-x" : "touch-pos-y";
        const el = document.getElementById(elId);
        if (el) {
          el.focus();
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    } else if (errors.value.targeting || errors.value.schedules) {
      currentStep.value = 2;
      // Targeting and schedules are in step 2
      nextTick(() => {
        // Can add IDs for these sections too if needed, but switching step might be enough visual cue or scroll to top
        const el = document.querySelector(".assignments-container");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
    return;
  }
  isSubmitted.value = true;
  const payload = createPayload("active");
  if (!update.value) createCampaign(payload);
  else editCampaign(payload);
};

const goToCampaigns = () => {
  router.push("/campaigns");
};

const createCampaign = (payload) => {
  campaignsStore
    .addCampaign({ companyId, data: payload })
    .then(() => {
      goToCampaigns();
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

const editCampaign = (payload) => {
  campaignsStore
    .editCampaign({
      companyId,
      id: id.value,
      data: payload,
    })
    .then(() => {
      goToCampaigns();
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

const cancel = () => {
  goToCampaigns();
};

const fetchCampaignById = async (id) => {
  await campaignsStore
    .fetchCampaignById({ companyId, id })
    .then((res) => {
      update.value = true;
      adName.value = res.data.name;
      adFormat.value = res.data.format;
      if (res.data.setting) {
        settings.value = res.data.setting;
      }
      campaignItems.value = res.data.items.map((item) => {
        const media = availableMedia.value.find((m) => m.id === item.id);
        return {
          ...item,
          type: media ? media.type : "image",
          url: media ? media.url : "",
        };
      });
      selectedStores.value = res.data.targeting.stores.map((s) => s.id);
      selectedAreas.value = res.data.targeting.areas.map((a) => a.id);
      selectedDevices.value = res.data.targeting.devices.map((d) => d.id);
      schedules.value = res.data.schedules;
      schedules.value.forEach((s) => {
        s.scheduleFrom = s.startDate ? new Date(s.startDate) : null;
        s.scheduleTo = s.endDate ? new Date(s.endDate) : null;
        s.startTime = s.startTime
          ? {
              hours: parseInt(s.startTime.split(":")[0]),
              minutes: parseInt(s.startTime.split(":")[1]),
              seconds: parseInt(s.startTime.split(":")[2]),
            }
          : null;
        s.endTime = s.endTime
          ? {
              hours: parseInt(s.endTime.split(":")[0]),
              minutes: parseInt(s.endTime.split(":")[1]),
              seconds: parseInt(s.endTime.split(":")[2]),
            }
          : null;

        s.scheduleType =
          s.type == "always"
            ? { name: "always", description: "Always" }
            : s.type == "weekly"
            ? { name: "weekly", description: "Weekly" }
            : s.type == "monthly"
            ? { name: "monthly", description: "Monthly" }
            : s.type == "yearly"
            ? { name: "yearly", description: "Yearly" }
            : { name: "always", description: "Always" };
        s.daysOfWeek = s.recurrence.daysOfWeek;
        s.daysOfWeek = daysOfWeekOptions.value.filter((d) => {
          return s.recurrence.daysOfWeek.includes(d.id);
        });
        s.daysOfMonth = s.recurrence.daysOfMonth;
        s.daysOfMonth = daysOfMonthOptions.value.filter((d) => {
          return s.recurrence.daysOfMonth.includes(d.id);
        });
        s.monthsOfYear = s.recurrence.monthsOfYear;
        s.monthsOfYear = monthsOfYearOptions.value.filter((m) => {
          return s.recurrence.monthsOfYear.includes(m.id);
        });
      });
      breadcrumbItems.value = [
        { text: "Campaigns", to: { name: "CampaignsView" } },
        { text: adName.value, active: true },
      ];
    })
    .catch(() => {});
};
const resetStoreData = () => {
  uiStore.resetModalStore();
};

onBeforeMount(async () => {
  await fetchStoresByName();
  await fetchAreasByName();
  await fetchDevicesByName();
  await fetchAllMedia();
  if (route.params.id) {
    id.value = route.params.id;
    await fetchCampaignById(route.params.id);
    resetStoreData();
  }
});
</script>

<template>
  <AgentLayout>
    <DBreadcrumb v-if="update" :items="breadcrumbItems" />
    <PageHeader
      :title="update ? 'Edit Campaign' : 'Create New Campaign'"
      subtitle="Configure advertisement playlist for kiosk displays"
      :showButton="false"
    />
    <div class="create-ad-container card" :class="{ 'is-assignments-step': currentStep === 2 }">
      <!-- Wizard Tabs Header -->
      <div class="wizard-tabs">
        <div
          class="tab-item"
          :class="{ active: currentStep === 1, completed: currentStep > 1 }"
          @click="currentStep = 1"
        >
          <span class="tab-number">1</span>
          <span class="tab-label">Campaign Setup</span>
        </div>
        <div class="tab-line"></div>
        <div
          class="tab-item"
          :class="{ active: currentStep === 2, completed: currentStep > 2 }"
          @click="currentStep = 2"
        >
          <span class="tab-number">2</span>
          <span class="tab-label">Assignments</span>
        </div>
      </div>

      <!-- Main Content Area -->
      <div class="wizard-content" :class="{ 'is-assignments-step': currentStep === 2 }">
        <!-- STEP 1: Campaign Setup (Split View) -->
        <div v-show="currentStep === 1" class="ad-editor-layout">
          <!-- Left Panel: Configuration -->
          <div class="config-panel">
            <!-- Select Ad Format -->
            <section class="step-section">
              <div class="step-header">
                <h2 class="step-title">Select Campaign Format</h2>
              </div>

              <div class="format-cards">
                <div
                  class="format-card"
                  :class="{ active: adFormat === 'screensaver' }"
                  @click="selectFormat('screensaver')"
                >
                  <div class="card-content">
                    <h3>Screensaver (Full Screen)</h3>
                    <p>1080x1920px • Best for idle mode attention grabbing.</p>
                  </div>
                  <div class="visual-indicator screensaver-visual"></div>
                </div>

                <div
                  class="format-card"
                  :class="{ active: adFormat === 'topbar' }"
                  @click="selectFormat('topbar')"
                >
                  <div class="card-content">
                    <h3>Topbar Banner</h3>
                    <p>1080x150px • daily visible on top during usage.</p>
                  </div>
                  <div class="visual-indicator topbar-visual"></div>
                </div>

                <div
                  class="format-card"
                  :class="{ active: adFormat === 'slider_basic' }"
                  @click="selectFormat('slider_basic')"
                >
                  <div class="card-content">
                    <h3>Slider Basic</h3>
                    <p>
                      1080x250px • daily visible on under of topbar during
                      usage.
                    </p>
                  </div>
                  <div class="visual-indicator slider-visual"></div>
                </div>
              </div>
            </section>

            <!-- Touch to Start Settings -->
            <section class="step-section" v-if="adFormat === 'screensaver'">
              <div class="step-header flex gap-3">
                <h2 class="step-title mb-0">Show touch to start</h2>
                <div class="form-check form-switch ps-0 mb-0">
                  <input
                    class="form-check-input ms-0"
                    type="checkbox"
                    id="touchToStart"
                    v-model="settings.screensaver.showTouchToStart"
                    style="cursor: pointer"
                    @change="updateTouchToStart"
                  />
                </div>
              </div>

              <div class="mt-3">
                <div class="grid grid-cols-12 gap-4">
                  <!-- Controls Column -->
                  <div class="col-span-12 md:col-span-7">
                    <div class="grid grid-cols-12 gap-3">
                      <!-- Row: Positions & Color -->
                      <div class="col-span-12">
                        <div class="form-group">
                          <label class="form-label text-sm font-medium"
                            >Pos X (%)</label
                          >
                          <div class="input-with-suffix">
                            <input
                              type="number"
                              id="touch-pos-x"
                              class="std-input"
                              :class="{ 'is-invalid': errors.touchToStartX }"
                              v-model="settings.screensaver.touchToStartX"
                              min="0"
                              max="100"
                              :disabled="!settings.screensaver.showTouchToStart"
                            />
                            <span class="suffix">%</span>
                          </div>
                          <span
                            v-if="errors.touchToStartX"
                            class="text-danger text-xs mt-1 block"
                            >{{ errors.touchToStartX }}</span
                          >
                        </div>
                      </div>
                      <div class="col-span-12">
                        <div class="form-group">
                          <label class="form-label text-sm font-medium"
                            >Pos Y (%)</label
                          >
                          <div class="input-with-suffix">
                            <input
                              type="number"
                              id="touch-pos-y"
                              class="std-input"
                              :class="{ 'is-invalid': errors.touchToStartY }"
                              v-model="settings.screensaver.touchToStartY"
                              min="0"
                              max="100"
                              :disabled="!settings.screensaver.showTouchToStart"
                            />
                            <span class="suffix">%</span>
                          </div>
                          <span
                            v-if="errors.touchToStartY"
                            class="text-danger text-xs mt-1 block"
                            >{{ errors.touchToStartY }}</span
                          >
                        </div>
                      </div>
                      <div class="col-span-12">
                        <div class="form-group">
                          <label class="form-label text-sm font-medium"
                            >Color</label
                          >
                          <input
                            type="color"
                            class="form-control form-control-color p-1 w-full"
                            id="touchColor"
                            v-model="settings.screensaver.touchToStartColor"
                            title="Choose your color"
                            :disabled="!settings.screensaver.showTouchToStart"
                            style="height: 38px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Preview Column -->
                  <div class="col-span-12 md:col-span-5">
                    <div class="flex flex-col h-full">
                      <label class="form-label text-sm font-medium mb-2"
                        >Preview</label
                      >
                      <div
                        class="flex items-center justify-center bg-light rounded border p-3 grow"
                        style="min-height: 200px"
                      >
                        <div
                          class="relative shadow-sm bg-white overflow-hidden border"
                          style="
                            width: 135px;
                            height: 240px;
                            border-radius: 8px;
                          "
                        >
                          <!-- Background Placeholder -->
                          <div
                            class="w-full h-full bg-dark opacity-25 flex items-center justify-center"
                          >
                            <i
                              class="bi bi-image text-gray-500 fs-1 opacity-50"
                            ></i>
                          </div>

                          <!-- Touch Overlay -->
                          <div
                            v-if="settings.screensaver.showTouchToStart"
                            class="absolute translate-x-[-50%] translate-y-[-50%] text-center pointer-events-none"
                            :style="{
                              left: `${settings.screensaver.touchToStartX}%`,
                              top: `${settings.screensaver.touchToStartY}%`,
                              color: settings.screensaver.touchToStartColor,
                              width: '100%',
                            }"
                          >
                            <div class="flex flex-col items-center">
                              <div
                                class="touch-animation-container"
                                :style="{
                                  color: settings.screensaver.touchToStartColor,
                                }"
                              >
                                <div class="touch-circle"></div>
                                <div class="touch-circle-delay"></div>
                                <i class="bi bi-hand-index-thumb-fill fs-3"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <!-- Campaign Details -->
            <section class="step-section">
              <div class="step-header">
                <h2 class="step-title">Campaign Details</h2>
              </div>
              <div class="w-full">
                <div class="form-group">
                  <label>Campaign Name</label>
                  <input
                    v-model="adName"
                    id="campaign-name"
                    type="text"
                    placeholder="e.g. Summer Sale Campaign"
                    class="std-input"
                    :class="{ 'is-invalid': errors.adName }"
                  />
                  <span
                    v-if="errors.adName"
                    class="text-danger mt-1 block text-sm"
                    >{{ errors.adName }}</span
                  >
                </div>
              </div>
            </section>

            <!-- Playlist -->
            <section class="step-section">
              <div class="step-header">
                <h2 class="step-title">Playlist & Schedule</h2>
              </div>

              <div
                class="assets-container"
                id="campaign-items"
                :class="{ 'is-invalid': errors.items }"
              >
                <div v-if="campaignItems.length === 0" class="empty-playlist">
                  <i class="bi bi-collection-play"></i>
                  <p>No media added to this campaign yet.</p>
                  <button
                    class="btn btn-primary-outline"
                    @click="openMediaModal"
                  >
                    <i class="bi bi-plus-lg"></i> Add Media
                  </button>
                </div>

                <div v-else class="playlist-wrapper">
                  <div class="playlist-actions">
                    <button
                      class="btn btn-primary-outline btn-sm"
                      @click="openMediaModal"
                    >
                      <i class="bi bi-plus-lg"></i> Add More Media
                    </button>
                  </div>

                  <transition-group
                    name="list"
                    tag="div"
                    class="playlist-items"
                  >
                    <div
                      v-for="(item, index) in campaignItems"
                      :key="item.id"
                      class="playlist-item"
                      draggable="true"
                      @dragstart="onDragStart(index, $event)"
                      @dragover="onDragOver"
                      @drop="onDrop(index)"
                      :class="{ dragging: draggedItemIndex === index }"
                    >
                      <div class="item-preview">
                        <i
                          class="bi bi-grip-vertical text-gray-500 mr-2"
                          style="cursor: grab"
                        ></i>
                        <span class="item-order">{{ index + 1 }}</span>
                        <img
                          v-if="item.type === 'image'"
                          :src="item.url"
                          class="item-thumb"
                        />
                        <video v-else :src="item.url" class="item-thumb" />
                        <div class="item-info">
                          <h4>{{ item.name }}</h4>
                          <!-- <span class="badge">{{ item.type }}</span> -->
                        </div>
                      </div>

                      <div class="item-config">
                        <div class="config-field">
                          <label>Duration</label>
                          <div class="flex items-center">
                            <div class="input-with-suffix">
                              <input
                                v-model="item.duration"
                                type="number"
                                class="std-input small-input"
                                :disabled="item.playUntilEnd"
                              />
                              <span class="suffix">s</span>
                            </div>
                            <div
                              v-if="item.type === 'video'"
                              class="form-check mb-0 ml-2 flex items-center"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                :id="`pue-${item.id}`"
                                v-model="item.playUntilEnd"
                              />
                              <label
                                class="form-check-label ml-1 text-gray-500 text-nowrap"
                                :for="`pue-${item.id}`"
                                style="font-size: 0.75rem; cursor: pointer"
                              >
                                Until End
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <button
                        class="remove-btn"
                        @click="removeCampaignItem(index)"
                      >
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                  </transition-group>
                </div>
              </div>

              <span
                v-if="errors.items"
                class="text-danger mt-2 block text-sm"
                >{{ errors.items }}</span
              >
            </section>
          </div>
        </div>

        <!-- STEP 2: Assignments -->
        <div v-show="currentStep === 2" class="assignments-layout">
          <div
            class="assignments-container"
            :class="{ 'is-invalid': errors.targeting }"
          >
            <!-- <div class="relative mb-3">
              <span v-if="stores.length" class="multiselect-title-span"
                >Sites (Optional)</span
              >
              <VMultiselect
                :class="{ 'multiselect-options': stores.length }"
                v-model="stores"
                :options="storesOptions"
                :disabled="false"
                :multiple="true"
                :searchable="true"
                :show-labels="false"
                placeholder="Sites (Optional)"
                trackBy="id"
                label="name"
                :loading="isStoresLoading"
                open-direction="bottom"
                :internal-search="false"
                :clear-on-select="false"
                :close-on-select="false"
                :show-no-results="true"
                :hide-selected="false"
                @search-change="searchByName($event, 'store')"
                selectLabel="Press enter to select"
                deselectLabel="Press enter to remove"
              >
                <template v-slot:noOptions>
                  <span>Search by site name</span>
                </template>
              </VMultiselect>
            </div> -->

            <FloatLabel class="w-full md:w-80 mb-3" variant="in">
              <PMultiSelect
                v-model="selectedStores"
                :options="storesOptions"
                :selectAll="selectAllStores"
                :disabled="!storesOptions.length"
                optionLabel="name"
                optionValue="id"
                @selectall-change="onSelectAllStoresChange($event)"
                @change="onChangeStoresVal($event)"
                :virtualScrollerOptions="{ itemSize: 30 }"
                filter
                class="custom-multiselect"
                panelClass="custom-multiselect-panel"
                display="chip"
                id="storesOptions"
                :maxSelectedLabels="2"
                :loading="isStoresLoading"
                filterPlaceholder="Search by site name"
              >
                <template #value="slotProps">
                  <div
                    v-if="slotProps.value && slotProps.value.length"
                    class="flex items-center"
                  >
                    <div v-if="slotProps.value.length > 2">
                      {{ slotProps.value.length }} items selected
                    </div>
                    <div v-else class="flex">
                      <div
                        v-for="id in slotProps.value"
                        :key="id"
                        class="p-multiselect-token"
                      >
                        <span class="p-multiselect-token-label">{{
                          getStoreName(id)
                        }}</span>
                        <span
                          class="p-multiselect-token-icon"
                          @click.stop="removeStore(id)"
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="p-icon"
                          >
                            <path
                              d="M10.5 3.5L3.5 10.5"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M3.5 3.5L10.5 10.5"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  <span v-else>
                    {{ slotProps.placeholder }}
                  </span>
                </template>
              </PMultiSelect>
              <label for="storesOptions">Sites (Optional)</label>
            </FloatLabel>

            <!-- <div class="relative mb-3">
              <span v-if="areas.length" class="multiselect-title-span"
                >Areas (Optional)</span
              >
              <VMultiselect
                :class="{ 'multiselect-options': areas.length }"
                v-model="areas"
                :options="areasOptions"
                :disabled="false"
                :multiple="true"
                :searchable="true"
                :show-labels="false"
                placeholder="Areas (Optional)"
                trackBy="id"
                label="name"
                :loading="isAreasLoading"
                open-direction="bottom"
                :internal-search="false"
                :clear-on-select="false"
                :close-on-select="false"
                :show-no-results="true"
                :hide-selected="false"
                @search-change="searchByName($event, 'area')"
                selectLabel="Press enter to select"
                deselectLabel="Press enter to remove"
              >
                <template v-slot:noOptions>
                  <span>Search by area name</span>
                </template>
              </VMultiselect>
            </div> -->

            <FloatLabel class="w-full md:w-80 mb-3" variant="in">
              <PMultiSelect
                v-model="selectedAreas"
                :options="areasOptions"
                :selectAll="selectAllAreas"
                :disabled="!areasOptions.length"
                optionLabel="name"
                optionValue="id"
                @selectall-change="onSelectAllAreasChange($event)"
                @change="onChangeAreasVal($event)"
                :virtualScrollerOptions="{ itemSize: 30 }"
                filter
                class="custom-multiselect"
                panelClass="custom-multiselect-panel"
                display="chip"
                id="areasOptions"
                :maxSelectedLabels="2"
                :loading="isAreasLoading"
                filterPlaceholder="Search by area name"
              >
                <template #value="slotProps">
                  <div
                    v-if="slotProps.value && slotProps.value.length"
                    class="flex items-center"
                  >
                    <div v-if="slotProps.value.length > 2">
                      {{ slotProps.value.length }} items selected
                    </div>
                    <div v-else class="flex">
                      <div
                        v-for="id in slotProps.value"
                        :key="id"
                        class="p-multiselect-token"
                      >
                        <span class="p-multiselect-token-label">{{
                          getAreaName(id)
                        }}</span>
                        <span
                          class="p-multiselect-token-icon"
                          @click.stop="removeArea(id)"
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="p-icon"
                          >
                            <path
                              d="M10.5 3.5L3.5 10.5"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M3.5 3.5L10.5 10.5"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  <span v-else>
                    {{ slotProps.placeholder }}
                  </span>
                </template>
              </PMultiSelect>
              <label for="areasOptions">Areas (Optional)</label>
            </FloatLabel>
            <!-- 
            <div class="relative mb-3">
              <span v-if="devices.length" class="multiselect-title-span"
                >Devices (Optional)</span
              >
              <VMultiselect
                :class="{ 'multiselect-options': devices.length }"
                v-model="devices"
                :options="devicesOptions"
                :disabled="false"
                :multiple="true"
                :searchable="true"
                :show-labels="false"
                placeholder="Devices (Optional)"
                trackBy="id"
                label="name"
                :loading="isDevicesLoading"
                open-direction="bottom"
                :internal-search="false"
                :clear-on-select="false"
                :close-on-select="false"
                :show-no-results="true"
                :hide-selected="false"
                @search-change="searchByName($event, 'device')"
                selectLabel="Press enter to select"
                deselectLabel="Press enter to remove"
              >
                <template v-slot:noOptions>
                  <span>Search by device name</span>
                </template>
              </VMultiselect>
            </div> -->

            <FloatLabel class="w-full md:w-80 mb-3" variant="in">
              <PMultiSelect
                v-model="selectedDevices"
                :options="devicesOptions"
                :selectAll="selectAllDevices"
                :disabled="!devicesOptions.length"
                optionLabel="name"
                optionValue="id"
                @selectall-change="onSelectAllDevicesChange($event)"
                @change="onChangeDevicesVal($event)"
                :virtualScrollerOptions="{ itemSize: 30 }"
                filter
                class="custom-multiselect"
                panelClass="custom-multiselect-panel"
                display="chip"
                id="devicesOptions"
                :maxSelectedLabels="2"
                :loading="isDevicesLoading"
                filterPlaceholder="Search by device name"
              >
                <template #value="slotProps">
                  <div
                    v-if="slotProps.value && slotProps.value.length"
                    class="flex items-center"
                  >
                    <div v-if="slotProps.value.length > 2">
                      {{ slotProps.value.length }} items selected
                    </div>
                    <div v-else class="flex">
                      <div
                        v-for="id in slotProps.value"
                        :key="id"
                        class="p-multiselect-token"
                      >
                        <span class="p-multiselect-token-label">{{
                          getDeviceName(id)
                        }}</span>
                        <span
                          class="p-multiselect-token-icon"
                          @click.stop="removeDevice(id)"
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="p-icon"
                          >
                            <path
                              d="M10.5 3.5L3.5 10.5"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M3.5 3.5L10.5 10.5"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  <span v-else>
                    {{ slotProps.placeholder }}
                  </span>
                </template>
              </PMultiSelect>
              <label for="devicesOptions">Devices (Optional)</label>
            </FloatLabel>

            <span
              v-if="errors.targeting"
              class="text-danger mt-1 block text-sm"
              >{{ errors.targeting }}</span
            >

            <!-- <div class="assignments-header">
              <h2>Target Locations</h2>
              <p>
                Select the kiosks, groups, or sites where this campaign should
                be displayed.
              </p>
            </div> -->

            <!-- <div class="locations-grid">
              <div
                v-for="loc in availableLocations"
                :key="loc.id"
                class="location-card"
                :class="{ selected: loc.selected }"
                @click="toggleLocation(loc.id)"
              >
                <div class="checkbox-circle">
                  <i class="bi bi-check-lg" v-if="loc.selected"></i>
                </div>
                <div class="loc-icon">
                  <i class="bi bi-display"></i>
                </div>
                <div class="loc-details">
                  <h3>{{ loc.name }}</h3>
                  <span class="loc-group">{{ loc.group }}</span>
                </div>
              </div>
            </div> -->
          </div>

          <div
            class="assignments-container schedule-section"
            :class="{ 'is-invalid': errors.schedules }"
          >
            <div class="flex justify-between items-center mb-4">
              <h3 class="subsection-title mb-0">Schedules</h3>
            </div>

            <div
              v-for="(schedule, index) in schedules"
              :key="schedule.id"
              class="schedule-block mb-4 p-3 border rounded"
            >
              <div
                class="flex justify-between items-center mb-3"
              >
                <h4 class="m-0 text-gray-500">Schedule {{ index + 1 }}</h4>
                <button
                  v-if="schedules.length > 1"
                  class="btn btn-sm text-danger"
                  @click="removeSchedule(index)"
                >
                  <i class="bi bi-trash"></i> Remove
                </button>
              </div>

              <div
                class="flex items-center justify-between mb-3"
              >
                <div class="flex">
                  <div class="relative">
                    <span
                      v-if="schedule.scheduleFrom"
                      class="datepicker-title-span"
                      >Schedule From</span
                    >
                    <VueDatePicker
                      :id="`schedule-from-picker-${index}`"
                      auto-apply
                      :clearable="schedule.scheduleFrom ? true : false"
                      format="dd/MM/yyyy"
                      v-model="schedule.scheduleFrom"
                      :month-change-on-scroll="false"
                      type="date"
                      :disabled-dates="disabledDates"
                      @update:model-value="changeScheduleFromDates(schedule)"
                      @time-picker-change="changeScheduleFromDates(schedule)"
                      @cleared="changeScheduleFromDates(schedule)"
                      @closed="changeScheduleFromDates(schedule)"
                      mode="date"
                      :enable-time-picker="false"
                    >
                      <template #dp-input="{ value }">
                        <input
                          placeholder="Schedule From"
                          type="text"
                          :value="value"
                          class="custom-date-picker"
                          :class="schedule.scheduleFrom ? 'pt-15' : ''"
                        />
                      </template>

                      <template v-if="!schedule.scheduleFrom" #input-icon>
                        <i class="input-slot-image">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              :fill="
                                schedule.scheduleFrom ? '#2D8425' : '#787878'
                              "
                              d="M0.666626 14.8327C0.666626 16.2493 1.74996 17.3327 3.16663 17.3327H14.8333C16.25 17.3327 17.3333 16.2493 17.3333 14.8327V8.16602H0.666626V14.8327ZM14.8333 2.33268H13.1666V1.49935C13.1666 0.999349 12.8333 0.666016 12.3333 0.666016C11.8333 0.666016 11.5 0.999349 11.5 1.49935V2.33268H6.49996V1.49935C6.49996 0.999349 6.16663 0.666016 5.66663 0.666016C5.16663 0.666016 4.83329 0.999349 4.83329 1.49935V2.33268H3.16663C1.74996 2.33268 0.666626 3.41602 0.666626 4.83268V6.49935H17.3333V4.83268C17.3333 3.41602 16.25 2.33268 14.8333 2.33268Z"
                            />
                          </svg>
                        </i>
                      </template>
                      <template
                        v-if="schedule.scheduleFrom"
                        #clear-icon="{ clear }"
                      >
                        <span @click="clear">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 22 22"
                            fill="none"
                          >
                            <path
                              fill="#F46A6A"
                              d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                            />
                          </svg>
                        </span>
                      </template>
                    </VueDatePicker>
                  </div>
                </div>
              </div>

              <div
                class="flex items-center justify-between mb-4"
              >
                <div class="flex">
                  <div class="relative">
                    <span
                      v-if="schedule.scheduleTo"
                      class="datepicker-title-span"
                      >Schedule To (Optional)</span
                    >
                    <VueDatePicker
                      :id="`schedule-to-picker-${index}`"
                      auto-apply
                      :clearable="schedule.scheduleTo ? true : false"
                      format="dd/MM/yyyy"
                      v-model="schedule.scheduleTo"
                      :month-change-on-scroll="false"
                      type="date"
                      :disabled-dates="getDisabledScheduleToDates(schedule)"
                      :disabled="!schedule.scheduleFrom"
                      :class="{ 'disabled-div': !schedule.scheduleFrom }"
                      mode="date"
                      :enable-time-picker="false"
                    >
                      <template #dp-input="{ value }">
                        <input
                          placeholder="Schedule To (Optional)"
                          type="text"
                          :value="value"
                          class="custom-date-picker"
                          :class="schedule.scheduleTo ? 'pt-15' : ''"
                        />
                      </template>

                      <template v-if="!schedule.scheduleTo" #input-icon>
                        <i class="input-slot-image">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              :fill="
                                schedule.scheduleTo ? '#2D8425' : '#787878'
                              "
                              d="M0.666626 14.8327C0.666626 16.2493 1.74996 17.3327 3.16663 17.3327H14.8333C16.25 17.3327 17.3333 16.2493 17.3333 14.8327V8.16602H0.666626V14.8327ZM14.8333 2.33268H13.1666V1.49935C13.1666 0.999349 12.8333 0.666016 12.3333 0.666016C11.8333 0.666016 11.5 0.999349 11.5 1.49935V2.33268H6.49996V1.49935C6.49996 0.999349 6.16663 0.666016 5.66663 0.666016C5.16663 0.666016 4.83329 0.999349 4.83329 1.49935V2.33268H3.16663C1.74996 2.33268 0.666626 3.41602 0.666626 4.83268V6.49935H17.3333V4.83268C17.3333 3.41602 16.25 2.33268 14.8333 2.33268Z"
                            />
                          </svg>
                        </i>
                      </template>
                      <template
                        v-if="schedule.scheduleTo"
                        #clear-icon="{ clear }"
                      >
                        <span @click="clear">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 22 22"
                            fill="none"
                          >
                            <path
                              fill="#F46A6A"
                              d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                            />
                          </svg>
                        </span>
                      </template>
                    </VueDatePicker>
                  </div>
                </div>
              </div>

              <div
                class="flex items-center justify-between mb-3"
              >
                <div class="flex">
                  <div class="relative">
                    <span
                      v-if="schedule.startTime"
                      class="datepicker-title-span"
                      >Start Time (Optional)</span
                    >
                    <VueDatePicker
                      :id="`start-time-picker-${index}`"
                      auto-apply
                      :clearable="schedule.startTime ? true : false"
                      format="HH:mm"
                      v-model="schedule.startTime"
                      :month-change-on-scroll="false"
                      type="time"
                      time-picker
                    >
                      <template #dp-input="{ value }">
                        <input
                          placeholder="Start Time (Optional)"
                          type="text"
                          :value="value"
                          class="custom-date-picker"
                          :class="schedule.startTime ? 'pt-15' : ''"
                        />
                      </template>

                      <template v-if="!schedule.startTime" #input-icon>
                        <i class="input-slot-image">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              :fill="schedule.startTime ? '#2D8425' : '#787878'"
                              d="M0.666626 14.8327C0.666626 16.2493 1.74996 17.3327 3.16663 17.3327H14.8333C16.25 17.3327 17.3333 16.2493 17.3333 14.8327V8.16602H0.666626V14.8327ZM14.8333 2.33268H13.1666V1.49935C13.1666 0.999349 12.8333 0.666016 12.3333 0.666016C11.8333 0.666016 11.5 0.999349 11.5 1.49935V2.33268H6.49996V1.49935C6.49996 0.999349 6.16663 0.666016 5.66663 0.666016C5.16663 0.666016 4.83329 0.999349 4.83329 1.49935V2.33268H3.16663C1.74996 2.33268 0.666626 3.41602 0.666626 4.83268V6.49935H17.3333V4.83268C17.3333 3.41602 16.25 2.33268 14.8333 2.33268Z"
                            />
                          </svg>
                        </i>
                      </template>
                      <template
                        v-if="schedule.startTime"
                        #clear-icon="{ clear }"
                      >
                        <span @click="clear">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 22 22"
                            fill="none"
                          >
                            <path
                              fill="#F46A6A"
                              d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                            />
                          </svg>
                        </span>
                      </template>
                    </VueDatePicker>
                  </div>
                </div>
              </div>

              <div
                class="flex items-center justify-between mb-3"
              >
                <div class="flex">
                  <div class="relative">
                    <span v-if="schedule.endTime" class="datepicker-title-span"
                      >End Time (Optional)</span
                    >
                    <VueDatePicker
                      :id="`end-time-picker-${index}`"
                      auto-apply
                      :clearable="schedule.endTime ? true : false"
                      format="HH:mm"
                      v-model="schedule.endTime"
                      :month-change-on-scroll="false"
                      type="time"
                      time-picker
                    >
                      <template #dp-input="{ value }">
                        <input
                          placeholder="End Time (Optional)"
                          type="text"
                          :value="value"
                          class="custom-date-picker"
                          :class="schedule.endTime ? 'pt-15' : ''"
                        />
                      </template>

                      <template v-if="!schedule.endTime" #input-icon>
                        <i class="input-slot-image">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              :fill="schedule.endTime ? '#2D8425' : '#787878'"
                              d="M0.666626 14.8327C0.666626 16.2493 1.74996 17.3327 3.16663 17.3327H14.8333C16.25 17.3327 17.3333 16.2493 17.3333 14.8327V8.16602H0.666626V14.8327ZM14.8333 2.33268H13.1666V1.49935C13.1666 0.999349 12.8333 0.666016 12.3333 0.666016C11.8333 0.666016 11.5 0.999349 11.5 1.49935V2.33268H6.49996V1.49935C6.49996 0.999349 6.16663 0.666016 5.66663 0.666016C5.16663 0.666016 4.83329 0.999349 4.83329 1.49935V2.33268H3.16663C1.74996 2.33268 0.666626 3.41602 0.666626 4.83268V6.49935H17.3333V4.83268C17.3333 3.41602 16.25 2.33268 14.8333 2.33268Z"
                            />
                          </svg>
                        </i>
                      </template>
                      <template v-if="schedule.endTime" #clear-icon="{ clear }">
                        <span @click="clear">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 22 22"
                            fill="none"
                          >
                            <path
                              fill="#F46A6A"
                              d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                            />
                          </svg>
                        </span>
                      </template>
                    </VueDatePicker>
                  </div>
                </div>
              </div>

              <div class="form-field mb-3">
                <label class="field-label" :for="`scheduleType_${schedule.id}`">Schedule Type</label>
                <PDropdown
                  v-model="schedule.scheduleType"
                  :inputId="`scheduleType_${schedule.id}`"
                  :options="scheduleTypeOptions"
                  optionLabel="description"
                  dataKey="name"
                  placeholder="Select Schedule Type"
                  class="w-full"
                  appendTo="body"
                  @change="onScheduleTypeChange(schedule)"
                />
              </div>

              <div
                v-if="schedule.scheduleType && schedule.scheduleType.name === 'weekly'"
                class="form-field mb-3"
              >
                <label class="field-label" :for="`daysOfWeek_${schedule.id}`">Days of Week</label>
                <PMultiSelect
                  v-model="schedule.daysOfWeek"
                  :inputId="`daysOfWeek_${schedule.id}`"
                  :options="daysOfWeekOptions"
                  optionLabel="name"
                  dataKey="id"
                  placeholder="Select days..."
                  class="w-full custom-multiselect"
                  panelClass="custom-multiselect-panel"
                  display="chip"
                  filter
                  filterPlaceholder="Search days..."
                  appendTo="body"
                />
              </div>

              <div
                v-if="schedule.scheduleType && schedule.scheduleType.name === 'monthly'"
                class="form-field mb-3"
              >
                <label class="field-label" :for="`daysOfMonth_${schedule.id}`">Days of Month</label>
                <PMultiSelect
                  v-model="schedule.daysOfMonth"
                  :inputId="`daysOfMonth_${schedule.id}`"
                  :options="daysOfMonthOptions"
                  optionLabel="name"
                  dataKey="id"
                  placeholder="Select days..."
                  class="w-full custom-multiselect"
                  panelClass="custom-multiselect-panel"
                  display="chip"
                  filter
                  filterPlaceholder="Search days..."
                  appendTo="body"
                />
              </div>

              <div
                v-if="schedule.scheduleType && schedule.scheduleType.name === 'yearly'"
                class="form-field mb-3"
              >
                <label class="field-label" :for="`monthsOfYear_${schedule.id}`">Months of Year</label>
                <PMultiSelect
                  v-model="schedule.monthsOfYear"
                  :inputId="`monthsOfYear_${schedule.id}`"
                  :options="monthsOfYearOptions"
                  optionLabel="name"
                  dataKey="id"
                  placeholder="Select months..."
                  class="w-full custom-multiselect"
                  panelClass="custom-multiselect-panel"
                  display="chip"
                  filter
                  filterPlaceholder="Search months..."
                  appendTo="body"
                />
              </div>
            </div>
            <!-- End of Schedule Block Loop -->

            <div class="flex justify-center mt-3">
              <button
                class="btn btn-primary-outline w-full py-3 dashed-btn"
                @click="addSchedule"
              >
                <i class="bi bi-plus-lg"></i> Add Schedule
              </button>
            </div>
            <span
              v-if="errors.schedules"
              class="text-red-500 mt-3 block text-center text-sm"
              >{{ errors.schedules }}</span
            >
          </div>
        </div>
      </div>

      <!-- Footer Actions -->
      <div class="actions-footer" :class="{ 'is-assignments-step': currentStep === 2 }">
        <button
          class="btn btn-secondary"
          @click="cancel"
          :disabled="isSubmitted"
        >
          Cancel
        </button>

        <div class="right-actions">
          <!-- Step 1 Nav -->
          <button
            v-if="currentStep === 1"
            class="btn btn-primary"
            @click="nextStep"
          >
            Next <i class="bi bi-arrow-right"></i>
          </button>

          <!-- Step 2 Nav -->
          <template v-if="currentStep === 2">
            <button class="btn btn-secondary" @click="prevStep">
              <i class="bi bi-arrow-left"></i>Back
            </button>
            <div class="separator-v"></div>
            <button
              class="btn btn-primary-outline"
              @click="saveDraft"
              :disabled="isSubmitted"
            >
              <i class="bi bi-save"></i> Save Draft
            </button>
            <button
              class="btn btn-primary"
              @click="saveAndPublish"
              :disabled="isSubmitted"
            >
              <i class="bi bi-cloud-upload"></i> Save & Publish
            </button>
          </template>
        </div>
      </div>

      <!-- Media Picker Modal -->
      <div v-if="showMediaModal" class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header">
            <h3>Select Media</h3>
            <button class="close-btn" @click="showMediaModal = false">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="flex justify-end mb-3">
              <div class="relative" style="width: 250px">
                <input
                  type="text"
                  class="std-input py-2 pe-5"
                  placeholder="Search media..."
                  v-model="mediaSearchQuery"
                />
                <div
                  class="absolute top-50 end-0 translate-middle-y mr-3 flex items-center"
                >
                  <div
                    v-if="isSearching"
                    class="spinner-sm text-secondary"
                    role="status"
                  ></div>
                  <i v-else class="bi bi-search text-secondary"></i>
                </div>
              </div>
            </div>
            <div v-if="selectableMedia.length === 0" class="empty-playlist">
              <i class="bi bi-card-image"></i>
              <p>No more media available to add.</p>
            </div>
            <div v-else class="media-grid">
              <div
                v-for="item in selectableMedia"
                :key="item.id"
                class="media-item"
                :class="{ selected: item.selected }"
                @click="toggleMediaSelection(item)"
              >
                <div class="selection-check" v-if="item.selected">
                  <i class="bi bi-check"></i>
                </div>
                <img
                  v-if="item.type !== 'video'"
                  :src="item.url"
                  :alt="item.name"
                  class="media-img"
                />
                <video
                  v-else
                  :src="item.url"
                  class="media-img"
                  preload="metadata"
                  muted
                  playsinline
                  onmouseover="this.play()"
                  onmouseout="this.pause()"
                ></video>
                <div class="item-info">
                  <div class="media-name">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showMediaModal = false">
              Cancel
            </button>
            <button class="btn btn-primary" @click="addSelectedMedia">
              Add Selection
            </button>
          </div>
        </div>
      </div>
    </div>
  </AgentLayout>
</template>

<style lang="scss" scoped>
.form-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.field-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
}

/* Reset and Base Vars */
.create-ad-container {
  color: var(--text-primary);
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  /* Assignments step has no side-by-side preview to keep in view, so let it
     grow with its content instead of scrolling inside a short internal box.
     A PrimeVue MultiSelect filter auto-focuses on open/select, and the
     browser's native "scroll focused element into view" then yanks whatever
     scroll container it's nested in — cramped nested containers turn that
     into a jarring jump. Handing scroll off to the page-level container
     (AgentLayout's already-scrollable .page-content) gives it far more room,
     so the same focus-driven scroll is no longer visually disruptive. */
  &.is-assignments-step {
    height: auto;
    overflow: visible;
  }
}

/* Layout */
.wizard-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &.is-assignments-step {
    flex: initial;
    min-height: auto;
    overflow: visible;
  }
}
.ad-editor-layout {
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
}
.config-panel {
  flex: 3;
  padding: 2rem;
  overflow-y: auto;
  border-right: 1px solid var(--border-color);
}
.preview-panel {
  flex: 2;
  background-color: var(--bg-secondary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  border-left: 1px solid var(--border-color);
  max-width: 450px;
}

/* Assignments Layout — flows naturally; the page itself scrolls it (see
   .create-ad-container.is-assignments-step above). */
.assignments-layout {
  background: var(--bg-secondary);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.assignments-container {
  background: white;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 2rem;
  width: 100%;
  flex-shrink: 0;
}
.assignments-container.schedule-section {
  flex: 1 0 auto;
}
.assignments-header {
  margin-bottom: 2rem;
  h2 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
}
.locations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
}
.location-card {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  transition: all 0.2s;
  background: white;

  &:hover {
    border-color: var(--primary-color);
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  }

  &.selected {
    border-color: var(--primary-color);
    background: #f8fbff;

    .checkbox-circle {
      background: var(--primary-color);
      border-color: var(--primary-color);
      color: white;
    }
  }
}
.checkbox-circle {
  width: 24px;
  height: 24px;
  border: 2px solid var(--border-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  transition: all 0.2s;
}
.loc-icon {
  font-size: 1.5rem;
  color: var(--text-secondary);
}
.loc-details h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}
.loc-group {
  font-size: 0.8rem;
  color: var(--text-secondary);
}

/* Common Components */
.step-section {
  margin-bottom: 2.5rem;
}
.step-header {
  margin-bottom: 1rem;
}
.step-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0;
}

/* Format Cards */
.format-cards {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.format-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  cursor: pointer;
  background-color: white;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: var(--primary-color);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }

  &.active {
    border: 2px solid var(--primary-color);
    background-color: #f8fbff;
    padding: calc(1.25rem - 1px) calc(1.5rem - 1px);
  }
}
.card-content {
  flex: 1;
}
.card-content h3 {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}
.card-content p {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin: 0;
}

.visual-indicator {
  width: 120px;
  height: 60px;
  border-radius: 6px;
  background-color: #e2e8f0;
  margin-left: 2rem;
  flex-shrink: 0;
}
.screensaver-visual {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
}
.topbar-visual {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  position: relative;
}
.topbar-visual::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 12px;
  background: var(--primary-color);
}
.slider-visual {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  position: relative;
}
.slider-visual::after {
  content: "";
  position: absolute;
  top: 12px;
  left: 0;
  right: 0;
  height: 24px;
  background: var(--primary-color);
}

/* Forms */
.form-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1.5rem;
}
.form-group label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: var(--text-secondary);
}
.std-input {
  width: 100%;
  padding: 0.625rem;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 0.9rem;
  &:focus {
    outline: none;
    border-color: var(--primary-color);
  }
}
.is-invalid {
  border-color: #dc3444 !important;
}

/* Playlist */
.assets-container {
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 1.5rem;
  background: #fff;
}
.empty-playlist {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  color: var(--text-secondary);
  i {
    font-size: 2rem;
  }
}
.playlist-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}
.playlist-items {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.playlist-item {
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid var(--border-color);
  padding: 0.75rem;
  border-radius: 8px;
  gap: 1rem;
  cursor: grab;
  transition: all 0.2s ease;

  &:active {
    cursor: grabbing;
  }

  &.dragging {
    opacity: 0.5;
    background: #f8fbff;
  }

  &:hover {
    border-color: var(--primary-color);
  }
}
.item-preview {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 2;
}
.item-thumb {
  width: 60px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
}
.item-info h4 {
  margin: 0 0 0.25rem 0;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-primary);
  max-width: 300px;
}
.badge {
  font-size: 0.75rem;
  background: var(--bg-secondary);
  padding: 2px 6px;
  border-radius: 4px;
}
.item-config {
  flex: 2;
}
.config-field label {
  display: block;
  font-size: 0.75rem;
  color: var(--text-secondary);
  // margin-bottom: 0.25rem;
}
.small-input {
  padding: 0.4rem;
  font-size: 0.85rem;
}
.input-with-suffix {
  position: relative;
  display: flex;
  align-items: center;
}
.suffix {
  position: absolute;
  right: 8px;
  color: var(--text-secondary);
  font-size: 0.8rem;
}
.remove-btn {
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0.5rem;
  &:hover {
    color: var(--danger-color);
  }
}

/* Footer */
.actions-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 2rem;
  background: white;
  border-top: 1px solid var(--border-color);
  z-index: 10;

  /* Step 1 keeps its fixed-height card (flex layout pins this at the
     bottom already). Step 2's card now grows with its content, so pin the
     footer to the viewport instead via the page's own scroll container. */
  &.is-assignments-step {
    position: sticky;
    bottom: 0;
  }
}
.right-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.separator-v {
  height: 24px;
  width: 1px;
  background: var(--border-color);
  margin: 0 0.5rem;
}

/* Buttons */
.btn {
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.btn-primary {
  background: var(--primary-color);
  color: white;
  &:hover {
    background: var(--primary-hover);
  }
}
.btn-secondary {
  background: white;
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  &:hover {
    background: var(--bg-secondary);
  }
}
.btn-primary-outline {
  border: 1px solid var(--primary-color);
  background: white;
  color: var(--primary-color);
  &:hover {
    background: #eff6ff;
  }
}
.btn-sm {
  padding: 0.4rem 0.8rem;
  font-size: 0.85rem;
}
.dashed-btn {
  border: 1px dashed var(--border-color);
  // background: transparent;
  border-color: var(--primary-color);
  background: #f8fbff;
  color: var(--text-primary);
  &:hover {
    border-color: var(--primary-color);
    background: #f8fbff;
    color: var(--primary-color);
  }
}

/* Preview */
.preview-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: auto;
}
.preview-header h3 {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--text-secondary);
  letter-spacing: 1px;
}
.device-frame {
  width: 300px;
  height: 533px;
  background: black;
  border-radius: 30px;
  border: 8px solid #333;
  overflow: hidden;
  margin: 2rem 0;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}
.screen-content {
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.preview-img-full {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Touch to Start Animation */
.touch-animation-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
}

.touch-circle,
.touch-circle-delay {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 4px solid currentColor; /* Uses color from parent style */
  opacity: 0;
  animation: ripple 2s infinite ease-out;
}

.touch-circle-delay {
  animation-delay: 0.5s;
}

@keyframes ripple {
  0% {
    transform: scale(0.1);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

.preview-overlay-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 1rem;
}
.ad-placeholder-content {
  color: white;
  text-align: center;
  p {
    opacity: 0.7;
  }
}
.preview-note {
  margin-top: auto;
  font-size: 0.8rem;
  color: var(--text-secondary);
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-content {
  background: white;
  width: 800px;
  max-width: 90%;
  height: 80%;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
}
.modal-header {
  padding: 1.5rem;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0;
  }
}
.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}
.modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem !important;
}
.modal-footer {
  padding: 1.5rem;
  border-top: 1px solid var(--border-color);
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
.media-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
}
.media-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.selected {
    border-color: var(--primary-color);
  }
  .selection-check {
    position: absolute;
    top: 8px;
    right: 8px;
    background: var(--primary-color);
    color: white;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .media-name {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    font-size: 0.75rem;
    padding: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

/* Transitions */
.list-enter-active,
.list-leave-active {
  transition: all 0.3s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

/* ── Dark mode ─────────────────────────────────────────────── */
[data-theme="dark"] {
  /* Format selection cards */
  .format-card {
    background-color: #28364e;

    &:hover { box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4); }

    &.active {
      background-color: #1a2d52;
      border-color: #4e7fff;
    }
  }

  /* Visual indicators (right-side previews on format cards) */
  .visual-indicator {
    background-color: #3d5070;
  }

  .topbar-visual,
  .slider-visual {
    background: #28364e;
    border-color: #3d5070;
  }

  /* Playlist / assets */
  .assets-container {
    background: #28364e;
  }

  .playlist-item {
    background: #28364e;

    &.dragging { background: #1a2d52; }
  }

  /* Footer bar */
  .actions-footer {
    background: #1e2a3e;
    border-top-color: #2d3f5a;
  }

  /* Buttons */
  .btn-secondary {
    background: #28364e;
    border-color: #3d5070;
    color: #e8edf5;

    &:hover { background: #3d5070; }
  }

  .btn-primary-outline {
    background: transparent;
    border-color: #4e7fff;
    color: #4e7fff;

    &:hover { background: #1a2d52; }
  }

  .dashed-btn {
    background: #1a2d52;
    border-color: #4e7fff;
    color: #a8c4ff;

    &:hover { background: #1e3460; color: #4e7fff; }
  }

  /* Media picker modal */
  .modal-content {
    background: #1e2a3e;
  }

  .modal-header {
    border-bottom-color: #2d3f5a;

    h3 { color: #e8edf5; }
  }

  .modal-footer {
    border-top-color: #2d3f5a;
  }

  .close-btn {
    color: #9aadc4;

    &:hover { color: #e8edf5; }
  }

  /* Assignments step */
  .assignments-container {
    background: #1e2a3e;
    border-color: #2d3f5a;
  }

  .location-card {
    background: #28364e;

    &.selected {
      background: #1a2d52;
    }
  }

  .checkbox-circle {
    border-color: #3d5070;
    color: #9aadc4;
  }
}
</style>
